/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminnav_Threads1Inputs */

const zh_adminnav_threads1 = /** @type {(inputs: Adminnav_Threads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会话管理`)
};

const en_adminnav_threads1 = /** @type {(inputs: Adminnav_Threads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation Management`)
};

const es_adminnav_threads1 = /** @type {(inputs: Adminnav_Threads1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de conversaciones`)
};

/**
* | output |
* | --- |
* | "Conversation Management" |
*
* @param {Adminnav_Threads1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminnav_threads1 = /** @type {((inputs?: Adminnav_Threads1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminnav_Threads1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminnav_threads1(inputs)
	if (locale === "en") return en_adminnav_threads1(inputs)
	return es_adminnav_threads1(inputs)
});
export { adminnav_threads1 as "adminNav_threads" }